import { EventTypeV2Card } from "./EventTypeV2Card";

export default EventTypeV2Card;
